import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import {
  approveRejectRequest,
  updateImages,
} from "../../../services/UserServices/UserService";

const photoFeedbackOptions = [
  {
    "en": "Please upload a real photo that clearly represents you. Blurred or cropped photos are allowed if they are still genuinely you. You can also keep selected photos or videos private and choose who gets access.",
    "ch": "Sila muat naik foto sebenar yang jelas mewakili diri anda. Foto yang kabur atau dipotong dibenarkan selagi ia benar-benar menggambarkan anda. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "zh": "请上传一张能够清楚代表您的真实照片。只要确实是您本人，模糊或裁剪过的照片也可以。您还可以将选定的照片或视频设为私密，并选择谁可以查看。",
    "ms": "Sila muat naik foto sebenar yang jelas mewakili diri anda. Foto yang kabur atau dipotong dibenarkan selagi ia benar-benar menggambarkan anda. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "id": "Silakan unggah foto asli yang jelas menunjukkan diri Anda. Foto yang buram atau dipotong tetap diperbolehkan selama benar-benar menampilkan Anda. Anda juga dapat menjadikan foto atau video tertentu bersifat pribadi dan memilih siapa yang dapat mengaksesnya.",
    "vi": "Vui lòng tải lên một ảnh thật thể hiện rõ bạn. Ảnh bị mờ hoặc cắt vẫn được chấp nhận nếu đó thực sự là bạn. Bạn cũng có thể đặt một số ảnh hoặc video ở chế độ riêng tư và chọn người được phép xem.",
    "ko": "본인을 명확하게 나타내는 실제 사진을 업로드해 주세요. 흐리거나 잘린 사진도 실제 본인이라면 허용됩니다. 특정 사진이나 동영상은 비공개로 설정하고, 접근 권한을 선택할 수도 있습니다.",
    "ja": "あなた本人であることがはっきり分かる実際の写真をアップロードしてください。ぼやけた写真やトリミングされた写真でも、本人であることが確認できれば問題ありません。また、特定の写真や動画を非公開にし、閲覧できる相手を選ぶこともできます。",
    "hi": "कृपया अपनी ऐसी वास्तविक फोटो अपलोड करें जो आपको स्पष्ट रूप से दर्शाती हो। यदि फोटो धुंधली या क्रॉप की हुई है, तब भी वह स्वीकार्य है, बशर्ते वह वास्तव में आपकी ही हो। आप चाहें तो चुनी गई फोटो या वीडियो को निजी रख सकते हैं और तय कर सकते हैं कि उन्हें कौन देख सकता है।"
  },
  {
    "en": "AI images, avatars, illustrations, or non-human images are not allowed. Please upload a real photo of yourself. Blurred or cropped photos are allowed if they are still genuinely you. You can also keep selected photos or videos private and choose who gets access.",
    "ch": "Imej AI, avatar, ilustrasi atau imej bukan manusia tidak dibenarkan. Sila muat naik foto sebenar diri anda. Foto yang kabur atau dipotong dibenarkan selagi ia benar-benar menggambarkan anda. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "zh": "不允许使用 AI 生成图片、头像、插画或非人类图片。请上传您本人的真实照片。只要确实是您本人，模糊或裁剪过的照片也可以。您还可以将选定的照片或视频设为私密，并选择谁可以查看。",
    "ms": "Imej AI, avatar, ilustrasi atau imej bukan manusia tidak dibenarkan. Sila muat naik foto sebenar diri anda. Foto yang kabur atau dipotong dibenarkan selagi ia benar-benar menggambarkan anda. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "id": "Gambar AI, avatar, ilustrasi, atau gambar non-manusia tidak diperbolehkan. Silakan unggah foto asli diri Anda. Foto yang buram atau dipotong tetap diperbolehkan selama benar-benar menampilkan Anda. Anda juga dapat menjadikan foto atau video tertentu bersifat pribadi dan memilih siapa yang dapat mengaksesnya.",
    "vi": "Không được phép sử dụng ảnh AI, avatar, hình minh họa hoặc hình ảnh không phải con người. Vui lòng tải lên ảnh thật của chính bạn. Ảnh bị mờ hoặc cắt vẫn được chấp nhận nếu đó thực sự là bạn. Bạn cũng có thể đặt một số ảnh hoặc video ở chế độ riêng tư và chọn người được phép xem.",
    "ko": "AI 생성 이미지, 아바타, 일러스트 또는 사람이 아닌 이미지는 허용되지 않습니다. 본인의 실제 사진을 업로드해 주세요. 흐리거나 잘린 사진도 실제 본인이라면 허용됩니다. 특정 사진이나 동영상은 비공개로 설정하고 접근 권한을 선택할 수도 있습니다.",
    "ja": "AIで生成された画像、アバター、イラスト、または人物以外の画像は使用できません。あなた本人の実際の写真をアップロードしてください。ぼやけた写真やトリミングされた写真でも、本人であることが確認できれば問題ありません。また、特定の写真や動画を非公開にし、閲覧できる相手を選ぶこともできます。",
    "hi": "AI से बनाई गई तस्वीरें, अवतार, चित्र या गैर-मानव छवियाँ स्वीकार नहीं हैं। कृपया अपनी वास्तविक फोटो अपलोड करें। यदि फोटो धुंधली या क्रॉप की हुई है, तब भी वह स्वीकार्य है, बशर्ते वह वास्तव में आपकी ही हो। आप चाहें तो चुनी गई फोटो या वीडियो को निजी रख सकते हैं और तय कर सकते हैं कि उन्हें कौन देख सकता है।"
  },
  {
    "en": "Profile photos should not include text, logos, watermarks, or promotional content.",
    "ch": "Foto profil tidak boleh mengandungi teks, logo, tera air atau kandungan promosi.",
    "zh": "头像照片不得包含文字、标志、水印或宣传内容。",
    "ms": "Foto profil tidak boleh mengandungi teks, logo, tera air atau kandungan promosi.",
    "id": "Foto profil tidak boleh berisi teks, logo, watermark, atau konten promosi.",
    "vi": "Ảnh hồ sơ không được chứa văn bản, logo, hình mờ hoặc nội dung quảng cáo.",
    "ko": "프로필 사진에는 텍스트, 로고, 워터마크 또는 홍보성 콘텐츠가 포함되어서는 안 됩니다.",
    "ja": "プロフィール写真には、文字、ロゴ、透かし、または宣伝目的のコンテンツを含めないでください。",
    "hi": "प्रोफ़ाइल फोटो में टेक्स्ट, लोगो, वॉटरमार्क या प्रचार संबंधी सामग्री नहीं होनी चाहिए।"
  },
  {
    "en": "Please upload a clearer, better-quality photo of yourself. Good lighting, clean framing, or a more natural setting can help your profile feel more real and trustworthy. You can also keep selected photos or videos private and choose who gets access.",
    "ch": "Sila muat naik foto diri anda yang lebih jelas dan berkualiti. Pencahayaan yang baik, pembingkaian yang kemas atau latar yang lebih semula jadi boleh menjadikan profil anda kelihatan lebih tulen dan dipercayai. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "zh": "请上传一张更清晰、更高质量的本人照片。良好的光线、清晰的构图或更自然的环境可以让您的个人资料显得更加真实和值得信赖。您还可以将选定的照片或视频设为私密，并选择谁可以查看。",
    "ms": "Sila muat naik foto diri anda yang lebih jelas dan berkualiti. Pencahayaan yang baik, pembingkaian yang kemas atau latar yang lebih semula jadi boleh menjadikan profil anda kelihatan lebih tulen dan dipercayai. Anda juga boleh menetapkan foto atau video tertentu sebagai peribadi dan memilih siapa yang boleh mengaksesnya.",
    "id": "Silakan unggah foto diri Anda yang lebih jelas dan berkualitas lebih baik. Pencahayaan yang baik, komposisi yang rapi, atau latar yang lebih alami dapat membuat profil Anda terlihat lebih nyata dan terpercaya. Anda juga dapat menjadikan foto atau video tertentu bersifat pribadi dan memilih siapa yang dapat mengaksesnya.",
    "vi": "Vui lòng tải lên ảnh của bạn rõ nét và chất lượng hơn. Ánh sáng tốt, bố cục gọn gàng hoặc khung cảnh tự nhiên sẽ giúp hồ sơ của bạn trở nên chân thực và đáng tin cậy hơn. Bạn cũng có thể đặt một số ảnh hoặc video ở chế độ riêng tư và chọn người được phép xem.",
    "ko": "더 선명하고 품질이 좋은 본인 사진을 업로드해 주세요. 좋은 조명, 깔끔한 구도 또는 자연스러운 배경은 프로필을 더욱 진정성 있고 신뢰감 있게 만들어 줍니다. 특정 사진이나 동영상은 비공개로 설정하고 접근 권한을 선택할 수도 있습니다.",
    "ja": "より鮮明で高品質なあなた自身の写真をアップロードしてください。明るい照明、整った構図、自然な背景は、プロフィールをより本物らしく信頼できる印象にします。また、特定の写真や動画を非公開にし、閲覧できる相手を選ぶこともできます。",
    "hi": "कृपया अपनी अधिक स्पष्ट और बेहतर गुणवत्ता वाली फोटो अपलोड करें। अच्छी रोशनी, साफ़ फ्रेमिंग या प्राकृतिक पृष्ठभूमि आपकी प्रोफ़ाइल को अधिक वास्तविक और भरोसेमंद बनाती है। आप चाहें तो चुनी गई फोटो या वीडियो को निजी रख सकते हैं और तय कर सकते हैं कि उन्हें कौन देख सकता है।"
  },
  {
    "en": "Final notice: Your account may be suspended if your profile photos continue to violate our guidelines. Please upload a real, appropriate photo that represents you clearly. Blurred or cropped photos are allowed, and selected photos or videos can be kept private.",
    "ch": "Notis terakhir: Akaun anda mungkin digantung jika foto profil anda terus melanggar garis panduan kami. Sila muat naik foto sebenar dan sesuai yang jelas mewakili diri anda. Foto yang kabur atau dipotong dibenarkan, dan foto atau video tertentu boleh disimpan sebagai peribadi.",
    "zh": "最后通知：如果您的头像照片继续违反我们的规定，您的账号可能会被暂停。请上传一张能够清楚代表您的真实且合适的照片。模糊或裁剪过的照片也可以，您还可以将选定的照片或视频设为私密。",
    "ms": "Notis terakhir: Akaun anda mungkin digantung jika foto profil anda terus melanggar garis panduan kami. Sila muat naik foto sebenar dan sesuai yang jelas mewakili diri anda. Foto yang kabur atau dipotong dibenarkan, dan foto atau video tertentu boleh disimpan sebagai peribadi.",
    "id": "Pemberitahuan terakhir: Akun Anda dapat ditangguhkan jika foto profil Anda terus melanggar pedoman kami. Silakan unggah foto asli yang sesuai dan jelas menunjukkan diri Anda. Foto yang buram atau dipotong diperbolehkan, dan foto atau video tertentu dapat disimpan sebagai pribadi.",
    "vi": "Thông báo cuối cùng: Tài khoản của bạn có thể bị tạm ngưng nếu ảnh hồ sơ tiếp tục vi phạm hướng dẫn của chúng tôi. Vui lòng tải lên một ảnh thật, phù hợp và thể hiện rõ bạn. Ảnh bị mờ hoặc cắt vẫn được chấp nhận và bạn có thể giữ một số ảnh hoặc video ở chế độ riêng tư.",
    "ko": "최종 안내: 프로필 사진이 계속해서 가이드라인을 위반할 경우 계정이 정지될 수 있습니다. 본인을 명확하게 나타내는 적절한 실제 사진을 업로드해 주세요. 흐리거나 잘린 사진도 허용되며, 특정 사진이나 동영상은 비공개로 설정할 수 있습니다.",
    "ja": "最終通知：プロフィール写真が引き続きガイドラインに違反している場合、アカウントが停止される可能性があります。あなた本人であることが明確に分かる適切な実際の写真をアップロードしてください。ぼやけた写真やトリミングされた写真も使用でき、特定の写真や動画は非公開に設定できます。",
    "hi": "अंतिम सूचना: यदि आपकी प्रोफ़ाइल फोटो हमारी गाइडलाइनों का उल्लंघन करती रही, तो आपका अकाउंट निलंबित किया जा सकता है। कृपया अपनी ऐसी वास्तविक और उपयुक्त फोटो अपलोड करें जो आपको स्पष्ट रूप से दर्शाती हो। धुंधली या क्रॉप की हुई फोटो भी स्वीकार्य है, और आप चुनी गई फोटो या वीडियो को निजी रख सकते हैं।"
  }
]



const ReasonForPicDelete = ({ show, id, deleteImages, table, onHide, femaleReasonForPicDelete }) => {
  const [reason, setReason] = useState("");
  const [textMessage, setTextMessage] = useState("");
  const [errors, setErrors] = useState({ reason: "", textMessage: "" });

  console.log("deleteImages", deleteImages);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        let message_en = "";
        let message_ch = "";
        let message_zh = "";
        let message_ms = "";
        let message_id = "";
        let message_vi = "";
        let message_ko = "";
        let message_ja = "";
        let message_hi = "";

        if (reason === "other") {
          message_en = textMessage;
          message_ch = textMessage;
          message_zh = textMessage;
          message_ms = textMessage;
          message_id = textMessage;
          message_vi = textMessage;
          message_ko = textMessage;
          message_ja = textMessage;
          message_hi = textMessage;
        } else {
          const selectedOption = photoFeedbackOptions.find(
            (item) => item.en === reason
          );
          message_en = selectedOption?.en || reason;
          message_ch = selectedOption?.ch || reason;
          message_zh = selectedOption?.zh || reason;
          message_ms = selectedOption?.ms || reason;
          message_id = selectedOption?.id || reason;
          message_vi = selectedOption?.vi || reason;
          message_ko = selectedOption?.ko || reason;
          message_ja = selectedOption?.ja || reason;
          message_hi = selectedOption?.hi || reason;
        }

        const payload = {
          userId: id,
          deleteImages: deleteImages.map((img) => img._id ?? img),
          reasonsToDeleteImages: message_en,
          reasonsToDeleteImages_ch: message_ch,
          reasonsToDeleteImages_zh: message_zh,
          reasonsToDeleteImages_ms: message_ms,
          reasonsToDeleteImages_id: message_id,
          reasonsToDeleteImages_vi: message_vi,
          reasonsToDeleteImages_ko: message_ko,
          reasonsToDeleteImages_ja: message_ja,
          reasonsToDeleteImages_hi: message_hi,
        };

        await updateImages(payload);
        notifyTopRight("Updated Successfully.");
        table();
        onHide();
        setReason("");
        setTextMessage("");
        femaleReasonForPicDelete();
      } catch (error) {
        notifyError(error.response?.data?.message || "An error occurred");
        console.error("Error:", error.response || error);
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errorObj = { reason: "", textMessage: "" };

    if (!reason) {
      errorObj.reason = "Reason is required";
      isValid = false;
    }
    if (reason === "other" && !textMessage.trim()) {
      errorObj.textMessage = "Reason is required";
      isValid = false;
    }

    setErrors(errorObj);
    return isValid;
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Reason for Media Removal</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Removal Reason <span className="text-danger">*</span></label>
            {/* <textarea
            rows={5}
            className="form-control"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setErrors({ ...errors, reason: "" });
            }}
          /> */}
            <select
              className="form-control"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                setErrors({ ...errors, reason: "" });
              }}
            >
              <option value="">Describe the reason for removing this image/video.</option>
              <option value="---">---</option>
              {photoFeedbackOptions.map((option, index) => (
                <option key={index} value={option.en}>
                  {option.en}
                </option>
              ))}
              <option value="other">Other</option>
            </select>
            {errors.reason && (
              <div className="text-danger fs-12">{errors.reason}</div>
            )}
          </div>
          {reason === "other" && (
            <div className="form-group mb-3">
              <label className="text-black font-w500">Reason Details</label>
              <textarea
                rows={5}
                className="form-control"
                value={textMessage}
                onChange={(e) => {
                  setTextMessage(e.target.value);
                  setErrors({ ...errors, textMessage: "" });
                }}
              />
              {errors.reason && (
                <div className="text-danger fs-12">{errors.reason}</div>
              )}
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" onClick={onHide} className="btn btn-danger">
            <i className="flaticon-delete-1"></i> Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ReasonForPicDelete;
